'use client';

import { useEffect, useRef } from 'react';
import { trackTracardi } from '~/utils';
import type { TripViewProperties } from '~/utils/journeyAnalytics';

type TracardiTripViewProps = { properties: TripViewProperties };

export const TracardiTripView = ({ properties }: TracardiTripViewProps) => {
  const lastTripId = useRef<string | null>(null);

  // Synchronises with Tracardi: sends one trip-viewed event per trip.
  useEffect(() => {
    if (lastTripId.current === properties.trip_id) return;
    lastTripId.current = properties.trip_id;
    trackTracardi('trip-viewed', properties);
  }, [properties]);

  return null;
};
